import { render, staticRenderFns } from "./TranslatorList.vue?vue&type=template&id=bd456644&"
import script from "./TranslatorList.vue?vue&type=script&lang=js&"
export * from "./TranslatorList.vue?vue&type=script&lang=js&"
import style0 from "./TranslatorList.vue?vue&type=style&index=0&id=bd456644&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports